import { listPunchLeaves } from "./punchLeaveCover";
import { listPunchPermits } from "./punchPermitCover";

const COMPENSATORY_HOURS_PER_FULL_DAY = 8;
const COMPENSATORY_HOURS_PER_HALF_DAY = 4;

function roundHours(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return 0;
  return Math.round(num * 100) / 100;
}

function compensatoryPermitHours(permits) {
  return listPunchPermits(permits).reduce((sum, permit) => {
    if (!permit?.isCompensatory) return sum;
    return sum + (Number(permit.hours) || 0);
  }, 0);
}

function compensatoryLeaveHours(leaves) {
  return listPunchLeaves(leaves).reduce((sum, leave) => {
    if (leave?.leaveType !== "COMPENSATORY") return sum;
    return (
      sum +
      (leave.halfDayPeriod
        ? COMPENSATORY_HOURS_PER_HALF_DAY
        : COMPENSATORY_HOURS_PER_FULL_DAY)
    );
  }, 0);
}

function isConvertedOvertime(day) {
  return day?.overtimeDisposition === "COMPENSATORY";
}

function isPendingOvertime(day) {
  const hours = Number(day?.overtimeHours) || 0;
  if (hours <= 0) return false;
  return (
    day?.overtimeDisposition === "PENDING" ||
    day?.overtimeDisposition === "REQUESTED" ||
    day?.overtimeDisposition == null
  );
}

export function summarizePunchMonth(days = [], monthTotals = null) {
  let working = 0;
  let overtime = 0;
  let convertedOvertime = 0;
  let pendingOvertime = 0;
  let compensatoryPermits = 0;
  let compensatoryLeave = 0;

  for (const day of days || []) {
    if (day?.empty) continue;
    working += Number(day.totalWorkingHours) || 0;
    const overtimeHours = Number(day.overtimeHours) || 0;
    overtime += overtimeHours;
    if (isConvertedOvertime(day)) convertedOvertime += overtimeHours;
    if (isPendingOvertime(day)) pendingOvertime += overtimeHours;
    compensatoryPermits += compensatoryPermitHours(day.permits);
    compensatoryLeave += compensatoryLeaveHours(day.leaves);
  }

  const remainingOvertimeHours = roundHours(
    Math.max(0, convertedOvertime - compensatoryPermits - compensatoryLeave),
  );

  const totals = {
    totalWorkingHours: roundHours(working),
    overtimeHours: roundHours(overtime),
    pendingOvertimeHours: roundHours(pendingOvertime),
    compensatoryPermitHours: roundHours(compensatoryPermits),
    remainingOvertimeHours,
    hasUnusedOvertime: remainingOvertimeHours > 0,
  };

  if (!monthTotals || typeof monthTotals !== "object") {
    return totals;
  }

  if (Number.isFinite(Number(monthTotals.compensatoryPermitHours))) {
    totals.compensatoryPermitHours = roundHours(
      monthTotals.compensatoryPermitHours,
    );
  }
  if (Number.isFinite(Number(monthTotals.remainingOvertimeHours))) {
    totals.remainingOvertimeHours = roundHours(
      monthTotals.remainingOvertimeHours,
    );
    totals.hasUnusedOvertime = totals.remainingOvertimeHours > 0;
  }
  return totals;
}
